import React, { Fragment, useEffect, useState } from 'react';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import useLatLng from 'hooks/uselatlng/uselatlng';
import CardSectionNew from 'components/sales/cardSection/cardSectionNew';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { ArrowRight, arrowRightBlue, tick } from 'assets/images/imageData';

const GateCard = ({
  history,
  data,
  match,
  islocationValid,
  locationApproval,
}) => {
  const islatlng = useLatLng();
  const [isModal, setIsModal] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isNotMatchModal, setNotMatchModal] = useState(false);
  const handleModalHide = () => setIsModal(false);
  
  const validateLocation = (url, id, gateId) => {
    if (islocationValid) {
      if (match.params.gate === 'site-inspection') {
        if (locationApproval?.status === 0) {
          history.push(`/dashboard/validate-location/${match.params.id}`);
        } else if (locationApproval?.status === 1) {
          setIsModal(true);
        } else if (locationApproval?.status === 2) {
          callFor(url, id, gateId);
        } else if (locationApproval?.status === 3) {
          isShowModal(true);
        }
      } else {
        if (locationApproval?.status === 0) {
          setNotMatchModal(true);
        } else if (locationApproval?.status === 1) {
          setIsModal(true);
        } else if (locationApproval?.status === 2) {
          callFor(url, id, gateId);
        } else if (locationApproval?.status === 3) {
          isShowModal(true);
        }
      }
    } else callFor(url, id, gateId);
  };
  const callFor = (url, id, gateId) => {
    if (url.includes('inventory')) {
      history.push({
        pathname: `/dashboard/inventory/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('siteInformationChecklist')) {
      history.push({
        pathname: `/dashboard/site-info/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('civilChecklistQuestions')) {
      history.push({
        pathname: `/dashboard/civil-check/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('hardware_installation_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/hardware-installation/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('handover_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/handover_checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('first_interaction_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/first_interaction_checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('configuration_and_testing')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/configuration_and_testing/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('valet_go_live_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/go_live/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    }
  };
  const viewChecklistAnswers = (url, id, gateId) => {
    if (url.includes('inventory')) {
      history.push({
        pathname: `/dashboard/inventory/${match.params.id}/stage/${match.params.stageId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('siteInformationChecklist')) {
      history.push({
        pathname: `/dashboard/site-info/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('civilChecklistQuestions')) {
      history.push({
        pathname: `/dashboard/civil-check/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
        state: { url: url, checklistId: id, gateId: gateId },
      });
    } else if (url.includes('hardware_installation_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/hardware-installation/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('handover_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/handover_checklist/view-checklist/${match.params.id}/stage/${match.params.stageId}`,
      });
    } else if (url.includes('first_interaction_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/first-interaction/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('configuration_and_testing')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/configuration-testing/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    } else if (url.includes('valet_go_live_checklist')) {
      history.push({
        state: { url: url, checklistId: id, gateId: gateId },
        pathname: `/dashboard/go_live/view-checklist/${match.params.id}/stage/${match.params.stageId}/${gateId}`,
      });
    }
  };
  return (
    <CardSectionNew
      title={
        data.hasOwnProperty('gate_no')
          ? `Solution ${data.gate_no}`
          : localization.handoverChecklist
      }
    >
       <h5>{data && data.gate_name ? data.gate_name : '' }</h5>
      {data &&
        data !== undefined &&
        data.checklist_data.map((obj, index) => {
          return (
            <>
            
            {(obj.checklist_name === 'Inventory Checklist' && (obj.completed === 1 || data.is_material_update === 1) ) ?
             null   
            :
            <Button
                key={index}
                disabled={obj.completed === 1 ? true : false}
                className={
                  obj.completed === 1
                    ? 'url-card card-success'
                    : 'url-card card-danger'
                }
                onClick={() => {
                  validateLocation(obj.url, obj.checklist_id, data.gate_id);
                }}
              >
                {obj.checklist_name}
              </Button>
            }
            {(obj.checklist_name !== 'Inventory Checklist' && (obj.completed === 1)) ? 
              <Button
                key={index+20}
                // className={'url-card card-success'}
                onClick={() => {
                  viewChecklistAnswers(obj.url, obj.checklist_id, data.gate_id);
                }}
                >
                {'View Checklist'}
              </Button>
              : null
            }
            
            </>
          );
        })}
      <ModalPop
        title={localization.note}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: 'red' }}>
            {localization.locationApprovalPending}
          </h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isShowModal}
        handleModalHide={() => {
          setIsShowModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: 'red' }}>
            {localization.locationApprovalRejected}
          </h5>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.note}
        show={isNotMatchModal}
        handleModalHide={() => {
          setNotMatchModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5 style={{ color: 'red' }}>{localization.locationDoesNotMatch}</h5>
        </div>
      </ModalPop>
    </CardSectionNew>
  );
};

export default GateCard;
